module.exports = __webpack_public_path__ + "img/selected3-min.30edd42f.png";